import React from "react";
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { sendAuditEvent } from "../utils/auditTrail";

const InvoiceTable = ({ tableData, searchQuery, defaultSorted, isMoveMusicDooUser, auditData }) => {
  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();
  const currencies = ["€", "$", "£"];

  const amountFormatter = (cell, row) => `${cell}${currencies[row.currency]}`;
  const logInvoiceFileClick = (fileType, fileUrl, invoiceId) => {
    sendAuditEvent({
      token: auditData?.token,
      eventType: 13,
      route: auditData?.route || window.location.pathname,
      entityType: "invoice",
      entityIds: [invoiceId],
      metadata: {
        file_type: fileType,
        file_url: fileUrl,
      },
    });
  };

  const downloadFormatter = (cell, row) =>
    cell ? (
      <a
        href={cell}
        target="blank"
        rel="noreferrer"
        onClick={() => {
          logInvoiceFileClick("invoice_pdf", cell, row.id);
        }}
      >
        <Button className="btn-status" color="primary">
          <b>{t("invoices.view.table.button.download")}</b>
        </Button>
      </a>
    ) : null;

  
  // const witholdingTaxStatementFormatter = cell =>
  //     cell ? (
  //       <a href={cell} target="blank">
  //         <Button className="btn-status" color="primary">
  //           <b>{t("invoices.view.table.button.download")}</b>
  //         </Button>
  //       </a>
  //     ) : t("invoices.view.table.label.notApplicable");

  const columns = [
    {
      dataField: "issue_date",
      text: t("invoices.view.table.column.issueDate"),
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "invoice_number",
      text: t("invoices.view.table.column.invoiceNumber"),
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "status",
      text: t("invoices.view.table.column.status"),
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "total_amount",
      text: t("invoices.view.table.column.totalAmount"),
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "invoice_pdf",
      text: t("invoices.view.table.column.downloadPDF"),
      formatter: (cell, row) => downloadFormatter(cell, row),
      headerStyle: () => ({ width: "100px" })
    },
    {
      dataField: "name",
      sort: false,
      csvExport: false,
      hidden: true,
    }
  ];

  // if (isMoveMusicDooUser) {
  //   columns.push({
  //     dataField: "wht_pdf",
  //     text: t("invoices.view.table.column.whtStatement"),
  //     formatter: witholdingTaxStatementFormatter,
  //     headerStyle: () => ({ width: "100px" })
  //   });
  // }

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "issue_date" || sortField === "invoice_number" || sortField === "status" || sortField === "total_due") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{ fileName: "invoices.csv" }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input
                  placeholder={t("invoices.view.table.placeholder.search")}
                  value={searchQuery.query}
                  style={{ marginBottom: 10 }}
                  onChange={e => searchQuery.setQuery(e.target.value)}
                />
              </div>
            </Col>
            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps}>
                  {t("invoices.view.table.button.exportCSV")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            remote={{ sort: true }}
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default InvoiceTable;